import { useMemo } from "react";
import { useWorkspaceConfig } from "../context/WorkspaceConfigContext";
import {
  WORKSPACE_SEGMENT_CONFIG_KEY,
  WorkspaceSegments,
  normalizeWorkspaceSegment,
} from "../constants/workspaceSegments";

export function useWorkspaceSegment() {
  const { byKey, isLoading, isError } = useWorkspaceConfig();

  const segment = useMemo(() => {
    const raw = byKey?.(WORKSPACE_SEGMENT_CONFIG_KEY, false, WorkspaceSegments.Generic);
    return normalizeWorkspaceSegment(raw);
  }, [byKey]);

  return {
    segment,
    isLoading,
    isError,
    isReady: !isLoading && !isError,
  };
}

